// FIXME This can probably go in /config

let apiPath = 'https://dev-admin-api.boxpressd.io';
let clientPath = 'https://dev.boxpressd.io';
let mediaPath = 'https://dev-media.boxpressd.io';
let shopPath = 'https://dev-shop-api.boxpressd.io';

if (window.location.hostname === 'admin.sigaro.io' || window.location.hostname === 'admin.boxpressd.io') {
  apiPath = 'https://admin-api.boxpressd.io';
  clientPath = 'https://api.boxpressd.io';
  mediaPath = 'https://media.boxpressd.io';
  shopPath = 'https://shop-api.boxpressd.io';
}

if (window.location.hostname === 'staging-admin.boxpressd.io') {
  apiPath = 'https://staging-admin-api.boxpressd.io';
  clientPath = 'https://api.boxpressd.io';
  mediaPath = 'https://media.boxpressd.io';
  // shopPath = 'https://staging-shop-api.boxpressd.io';
  shopPath = 'https://shop-api.boxpressd.io';
}

// eslint-disable-next-line import/prefer-default-export
export const Constants = {
  apiPath,
  clientPath,
  shopPath,
  mediaPath,
  googleMapsKey: 'AIzaSyBMloRcukeyA4eNwgwqbZxGCcwPNlC1qvc',
};
